import { IconButton } from '@sparemin/blockhead';
import styled from 'styled-components';

export const Button = styled(IconButton)`
  margin-left: 12px;
  margin-right: 16px;
`;
